<div class="container p-2 bg-white rounded event-container">
  <!-- Invoice Image -->
  <div (mouseover)="animationEvent('in')" (mouseleave)="animationEvent('out')"
       [ngStyle]="{'background-image': 'url(' + calendarImage + ')'}" id="product-cover">
    <div class="p-2" id="product-cover-tag">
      <!--<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24">
    <g><rect fill="none" height="24" width="24" /></g>
    <g><path d="M15,3l2.3,2.3l-2.89,2.87l1.42,1.42L18.7,6.7L21,9V3H15z M3,9l2.3-2.3l2.87,2.89l1.42-1.42L6.7,5.3L9,3H3V9z M9,21 l-2.3-2.3l2.89-2.87l-1.42-1.42L5.3,17.3L3,15v6H9z M21,15l-2.3,2.3l-2.87-2.89l-1.42,1.42l2.89,2.87L15,21fs-6V15z" /></g>
  </svg>-->
      {{ 'Buyer.Hover' | translate }}
    </div>
  </div>
  <div class="product-content">
    <!-- Info Bar -->
    <div id="info-bar" class="mb-5">
      <div class="info-bar-header">
        {{productObject['productName']}}
      </div>
      <div class="info-bar-body">
        <div class="row mx-0 align-items-center">
          <div class="col-12 col-sm-12 col-md-12">
            <div class="info-bar-title">{{ 'Buyer.HostedBy' | translate }}</div>
            <div class="info-bar-value">
              <a target="_blank" routerLink="/{{businessObject?.name}}">
                <div class="text-white">{{businessObject?.name}}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Description -->
    <div class="payment-card mb-5">
      <div class="payment-card-header">{{ 'Buyer.Description' | translate }}</div>
      <div class="payment-card-body">
        <app-read-more textValue="{{ getNewProductValueByFieldName('description', 'ProductExtraInfos') }}">
        </app-read-more>
      </div>
    </div>

    <!-- Product Tickets -->
    <div class="payment-card mb-5">
      <div class="payment-card-header">{{ 'Buyer.ChooseDate' | translate }}</div>
      <div class="payment-card-body">
        <div class="row justify-content-center">
          <mat-calendar (selectedChange)="handleDateChange($event)"
                        [dateFilter]="availableDaysFilter"
                        class="col-md-6 col-lg-4 border rounded"></mat-calendar>
        </div>
        <!-- [dateClass]="dateClass" -->
      </div>
    </div>

    <!-- Product Tickets -->
    <div class="payment-card mb-5" *ngIf="!!parsedSlots">
      <div class="payment-card-header">{{ 'Buyer.Slots' | translate }}</div>
      <div class="payment-card-body">
        <div id="TicketExample" *ngFor="let slot of parsedSlots">
          <div class="row mx-0 align-items-center rounded Ticket">
            <!-- Slot bigger than 0 -->
            <div class="row align-items-center rounded mx-4 mx-lg-0 Ticket"
                 *ngIf="slot.quantity > 0">
              <div class="col-12 text-center p-3 TicketRight">
                <div class="row align-items-baseline">
                  <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-3 mt-lg-0">
                    <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.StartsAt' | translate }}</div>
                    <div style="font-size: 0.8rem">
                      {{ slot.startAt || "N/A" }}
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-3 mt-lg-0">
                    <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.EndsAt' | translate }}</div>
                    <div style="font-size: 0.8rem">{{ slot.endAt || "N/A" }}</div>
                  </div>
                  <div class="no-padding col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-3 mt-lg-0">
                    <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Quantity' | translate }}</div>
                    <div style="transform: scale(0.8)"
                         class="row justify-content-center">
                      <button class="col-3 px-0 btn-ticket"
                              (click)="quantityDownChange($event, slot.price, slot.id, slot.maxQuantityPerSale, 'prev')"
                              type="button" onclick="this.nextElementSibling.stepDown()">
                        -
                      </button>
                      <input type="number" min="0" max="{{ slot.maxQuantityPerSale }}" [value]="slot.selectedQuantity" readonly
                             class="col-6 px-0 form-number-control text-center" />
                      <button class="col-3 px-0 btn-ticket"
                              (click)="quantityUpChange($event, slot.price, slot.id, slot.maxQuantityPerSale, 'next')"
                              type="button" onclick="this.previousElementSibling.stepUp()">
                        +
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-3 mt-lg-0">
                    <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Price' | translate }}</div>
                    <div style="font-size: 0.8rem">
                      {{ subtotal.toFixed(2) }}
                      {{ getNewProductValueByFieldName("currency", "ProductExtraInfos") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Slot smaller than or equal 0 -->
            <div class="row align-items-center rounded mx-4 mx-lg-0 Ticket"
                 *ngIf="slot.quantity <= 0">
              <div class="col-12 text-center p-3 TicketRight">
                <div class="row align-items-baseline">
                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-4 mt-lg-0">
                    <p class="soldOut">{{ 'Buyer.SoldOut' | translate }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Ads -->
    <div class="mb-4">
      <!--<app-ads [productObject]="productObject"></app-ads>-->
    </div>

    <div class="row mx-0 justify-content-end">
      <div class="col-auto px-0">
        <button class="btn btn-primary" type="button" [disabled]="subtotal <= 0" (click)="proceedToPayment()">{{ 'Buyer.Next' | translate }}</button>
      </div>
    </div>
  </div>

</div>
